import { IvcfAplicacaoModel, IvcfFieldModel } from './ivcf/model-ivcf'
import { PuericulturaModel } from './puericultura/model'

export interface EvolucaoObjetivoQueryModel {
  id: ID
  descricao?: string
}

export enum FormAtivoObjetivoEnum {
  PUERICULTURA = 'PUERICULTURA',
  PRE_NATAL = 'PRE_NATAL',
  IVCF = 'IVCF',
}

export interface SwitchButtonObjetivoFormModel {
  formAtivo?: FormAtivoObjetivoEnum
  puericultura?: PuericulturaModel
  ivcf?: IvcfFieldModel
  ivcfCache?: IvcfAplicacaoModel
}
